<template>
  <div>
    <component :is="cModule" />
  </div>
</template>

<script>
export default {
  components: {
    CModuleLoad: () => import('./load.vue'),
    CModuleBasic: () => import('./basic/index.vue'),
    CModuleRadio: () => import('./radio/index.vue'),
  },
  scrollToTop: true,
  data() {
    let cModule = 'c-module-load'
    const content = this.$store.state.player.content

    if (['radio', 'stream'].includes(content.type)) {
      cModule = 'c-module-radio'
    } else {
      cModule = 'c-module-basic'
    }

    return {
      cModule,
    }
  },
}
</script>
